export enum CurrencyConversionProviderType {
    Airwallex = 'airwallex',
    Wise = 'wise',
}
